import { render } from "./VideoPreview.vue?vue&type=template&id=25d1811c&scoped=true"
import script from "./VideoPreview.vue?vue&type=script&lang=js"
export * from "./VideoPreview.vue?vue&type=script&lang=js"

import "./VideoPreview.vue?vue&type=style&index=0&id=25d1811c&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-25d1811c"]])

export default __exports__